<template>
  <div>
    <h1 class="heading sticky-top">
      {{ organization.name }} Dashboard
    </h1>
    <div class="container-fluid">
      <div class="row">
        <nav class="col-sm-2 col-md-2 d-block bg-light sidebar">
          <div class="sidebar-sticky pt-3">
            <ul class="nav flex-column">
              <li
                class="nav-item"
                @click="setTab(Tabs.RESERVATIONS)"
              >
                <span
                  class="nav-link"
                  :class="getClass(Tabs.RESERVATIONS)"
                >
                  <b-icon-calendar
                    style="width: 24px; height: 24px;"
                    class="nav-link-icon"
                  />
                  Reservations<span class="sr-only">(current)</span>
                </span>
              </li>
              <li
                class="nav-item"
                @click="setTab(Tabs.MEMBERS)"
              >
                <span
                  class="nav-link"
                  :class="getClass(Tabs.MEMBERS)"
                >
                  <b-icon-people
                    class="nav-link-icon"
                    style="width: 24px; height: 24px;"
                  />
                  Members <span class="sr-only">(current)</span>
                </span>
              </li>
            </ul>
            <div
              class="nav-link sidebar-heading d-flex justify-content-between align-items-center mt-4"
            >
              <span>
                Organization
                <!--<b-icon-plus scale="1.2" />-->
              </span>
            </div>
            <ul
              v-if="organizationTabExpanded"
              class="nav flex-column mt-0"
              style="margin-left: .5rem;"
            >
              <li
                class="nav-item"
                @click="setTab(Tabs.SETTINGS)"
              >
                <span
                  class="nav-link"
                  :class="getClass(Tabs.SETTINGS)"
                >
                  <b-icon-toggles
                    class="nav-link-icon"
                    style="width: 24px; height: 24px;"
                  />
                  Settings <span class="sr-only">(current)</span>
                </span>
              </li>
              <li
                class="nav-item"
                @click="setTab(Tabs.MANAGERS)"
              >
                <span
                  class="nav-link"
                  :class="getClass(Tabs.MANAGERS)"
                >
                  <b-icon-people
                    class="nav-link-icon"
                    style="width: 24px; height: 24px;"
                  />
                  Managers <span class="sr-only">(current)</span>
                </span>
              </li>
              <li
                class="nav-item"
                @click="setTab(Tabs.COURTS)"
              >
                <span
                  class="nav-link"
                  :class="getClass(Tabs.COURTS)"
                >
                  <b-icon-geo
                    class="nav-link-icon"
                    style="width: 24px; height: 24px;"
                  />
                  Courts <span class="sr-only">(current)</span>
                </span>
              </li>
            </ul>
          </div>
        </nav>
        <main
          role="main"
          class="col-sm-9 col-md-9 ml-sm-auto col-lg-10 pt-3 px-4"
        >
          <Reservations v-if="currentTab === Tabs.RESERVATIONS" />
          <Courts v-else-if="currentTab === Tabs.COURTS" />
          <Managers v-else-if="currentTab === Tabs.MANAGERS" />
          <Members v-else-if="currentTab === Tabs.MEMBERS" />
          <Settings v-else-if="currentTab === Tabs.SETTINGS" />
        </main>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Reservations from './Reservations';
import Tabs from './Tabs';
import Courts from './Courts';
import Managers from './Managers';
import Members from './Members';
import Settings from './Settings';

export default {
  name: 'OrgManagementIndex'.toLowerCase(),
  components: {
    Courts,
    Managers,
    Members,
    Reservations,
    Settings,
  },
  props: {
    organization: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    Tabs,
    currentTab: Tabs.RESERVATIONS,
    organizationTabExpanded: true,
  }),
  created(){
    this.setCurrentOrganization({
      organization: JSON.parse(this.organization),
    });
    const location = window.location.hash.substr(1);
    this.currentTab = Tabs[location.toUpperCase()] || Tabs.RESERVATIONS;
  },
  methods: {
    ...mapActions([
      'setCurrentOrganization',
    ]),
    getClass(tabName){return this.currentTab === tabName? 'active':''; },
    setTab(tabName){
      this.currentTab = Tabs[tabName.toUpperCase()];
      window.location.hash = tabName;
    },
    toggleNavItem(){
      this.organizationTabExpanded = !this.organizationTabExpanded;
    },
  },
};
</script>

<style scoped>
    .sidebar-sticky {
        position: -webkit-sticky;
        position: sticky;
        top: 48px;
        height: calc(100vh - 48px);
        padding-top: .5rem;
        overflow-x: hidden;
        overflow-y: auto;
    }

    .sidebar-heading {
        font-size: 1rem;
        text-transform: uppercase;
    }

    .sidebar .nav-link:hover .feather, .sidebar .nav-link.active .feather {
        color: inherit;
    }

    .nav-link-icon {
      margin-right: .5rem;
    }

    .nav-link.active {
        background-color: #CCC;
        border-radius: 5px;
    }

    .nav-link:hover {
        cursor: pointer;
    }

    .sidebar .nav-link .feather {
        margin-right: 4px;
        color: #999;
    }
</style>
